import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"


export const PROPERTY = "preferences.actionBoardUrl"

export const schema = Validation.string().url("Must be a valid URL")


const ActionBoardUrl = ({schedule, onChange, required, label, ...props}) => {
  return (
    <Input
      {...props}
      id={id(PROPERTY, props)}
      name={PROPERTY}
      type="text"
      value={get(schedule, PROPERTY)}
      onChange={(value) => onChange(schedule, PROPERTY, value)}
      label={`${label}${required ? "*" : ""}`} />
  )
}

ActionBoardUrl.propTypes = {
  schedule: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string,
  validation: PropTypes.object
}

ActionBoardUrl.defaultProps = {
  required: true,
  label: "Action board link",
  hint: "Please start URL's with either http:// or https://",
  validation: schema
}

export default ActionBoardUrl
